import React from "react";
import styled from "styled-components";
import { PersonalInfo } from "../data";
import { Column } from "../Styles/StyledComponents";

const SkillsSection = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const SkillBox = styled.div`
  flex: 1;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;

  h2 {
    color: #fff;
    margin-bottom: 1rem;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    padding: 0.5rem 0;
    color: #fff;
    &:before {
      content: "•";
      margin-right: 0.5rem;
    }
  }
`;
const Container = styled(Column)`
  align-items: center;
  margin-top: 40px;
  gap: 20px;
  text-align: center;
`;

const ProfileImage = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 5px solid rgb(238, 231, 166);

  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
  }
`;

const AboutText = styled.p`
  line-height: 1.6;
  max-width: 75vw;
  margin: 10px;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const CVButton = styled.a`
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  color: white;
  background-color: #007bff;
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

const AboutMe: React.FC = () => {
  return (
    <div>
    <Container>
      <ProfileImage src={PersonalInfo.image} alt="Your Name" />
      <AboutText>
       {PersonalInfo.description}
      </AboutText>
            <CVButton href={`${PersonalInfo.cvUri}`} download>
        Download My CV
      </CVButton>
    </Container>

    <SkillsSection>
        <SkillBox>
          <h2>Skills</h2>
          <ul>
            {PersonalInfo.skills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>
        </SkillBox>

        <SkillBox>
          <h2>Tools</h2>
          <ul>
            {PersonalInfo.tools.map((tool, index) => (
              <li key={index}>{tool}</li>
            ))}
          </ul>
        </SkillBox>
      </SkillsSection>


    </div>
  );
};

export default AboutMe;